module.exports = __webpack_public_path__ + "static/media/30.eaa1804a.jpg";